import React, { useEffect, useState } from 'react';
import { fetchSlots, bookSlot, fetchBookingPeriod } from './slotsApi';
import './Slots.css';
import SlotItem from './SlotItem';
import { useDispatch, useSelector } from 'react-redux';
import { selectUser, selectUserEmail, setUser } from '../Auth/authSlice';
import { useNavigate } from 'react-router-dom';
import { fetchUserById } from '../Auth/authApi';
import ModalAudio from './ModalAudio';

const DEFAULT_INTERVAL_DAYS = 21;

const Slots = ({ onBooked }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(true); // 👈 для окна
  const [intervalDays, setIntervalDays] = useState(DEFAULT_INTERVAL_DAYS);
  const email = useSelector(selectUserEmail);
  const user = useSelector(selectUser);

  useEffect(() => {
    const loadSlots = async () => {
      try {
        const [data, period] = await Promise.all([
          fetchSlots(),
          fetchBookingPeriod().catch(() => null),
        ]);
        console.log('slots', data)
        if (period?.intervalDays) {
          setIntervalDays(period.intervalDays);
        }
        const slotsWithFormattedDate = data.map((slot) => ({
          ...slot,
          formattedDate: formatDate(slot.datetime),
        }));
        setSlots(slotsWithFormattedDate);

        if (user?.id) {
          const result = await fetchUserById(user.id);
          if (result.user) {
            dispatch(setUser(result.user));
          }
        }


      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadSlots();
  }, []);

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return (
      date.toLocaleDateString('ru-RU', {
        weekday: 'short',
        day: '2-digit',
        month: '2-digit',
      }) +
      ' ' +
      date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
    );
  };

  const handleBook = async (slotId) => {
    try {
      console.log('email', user?.email)
      const result = await bookSlot(slotId, user?.email, 'user', user);
      // alert('Вы успешно записались на слот');
      const slot = slots.find((s) => s.id === slotId);
      // navigate('/myslots');
      const enrichedSlot = { ...slot, anket_id: result.anketId };

      navigate('/anketa', { state: { slot: enrichedSlot } });
      if (onBooked) onBooked();
    } catch (err) {
      alert(`Ошибка бронирования: ${err.message}`);
    }
  };

  /** Слот недоступен, если он в прошлом или ближе intervalDays к любой уже существующей записи */
  const getDisableBooking = (slotDate) => {
    const now = new Date();
    const slot = new Date(slotDate);
    if (slot < now) return true;

    const dateStr = user?.futureAnkets?.dates;
    if (!dateStr) return false;

    const intervalMs = intervalDays * 24 * 60 * 60 * 1000;
    const dates = String(dateStr)
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean)
      .map((s) => new Date(s));

    return dates.some((userDate) => {
      if (Number.isNaN(userDate.getTime())) return false;
      return Math.abs(slot.getTime() - userDate.getTime()) < intervalMs;
    });
  };

  if (loading) return <div>Загрузка...</div>;
  if (error) return <div>Ошибка: {error}</div>;

  return (
    <div>
      {/* 💬 Текст по центру */}
      <div style={{ textAlign: 'center', marginBottom: '20px', fontWeight: 'bold' }}>
        Благодарим Вас за обращение в официальную русскоязычную группу Когерентного Исцеления доктора Джо Диспенза «Единое Сердце».
      </div>

      {/* 💡 Модальное окно */}
      {showModal && (
        <ModalAudio setShowModal={setShowModal}/>
      )}

      <div className="slots-container">
        {slots.map((slot) => (
          <SlotItem
            key={slot.id}
            slot={slot}
            onBook={handleBook}
            disableBooking={getDisableBooking(slot.datetime)}
          />
        ))}
      </div>
    </div>
  );
};

export default Slots;
